<template>
  <div class="min-body">
    <!-- banner -->
    <banner :banner-list="bannerList"></banner>
    <!-- 方案功能 -->
    <SectionTitle :title="$t('sectionTitle.solutionFeatures')" subtitle="" style="margin:100px 0 50px 0;" />
    <FeatureGrid :featureList="featureList"></FeatureGrid>
    <SectionTitle :title="$t('sectionTitle.solutionArchitecture')" subtitle="" style="margin:100px 0 50px 0;" />
    <img class="fajg-img" :src="featureImage" >
    <SectionTitle :title="$t('sectionTitle.solutionAdvantages')" subtitle="" style="margin:100px 0 50px 0;" />
    <FeatureSection :featureSectionList="featureSectionList"></FeatureSection>

    <SectionTitle :title="$t('sectionTitle.customerCase')" subtitle="" style="margin:100px 0 30px 0;" />
    <CustomerCase :caseList="caseList"></CustomerCase>



    <!-- Footer -->
    <Footer></Footer>
    <!--END!-->
  </div>
</template>

<script>
import Footer from '@/components/Footer'
import banner from "@/views/Home/components/Banner/banner.vue";
import SectionTitle from "@/components/SectionTitle/index.vue";
import FeatureGrid from "./components/FeatureGrid/index.vue"
import FeatureSection from "./components/FeatureSection/index.vue"
import CustomerCase from "@/views/Home/components/CustomerCase/index.vue";
import Algorithm from "@/config/Algorithm.js"
export default {
  name: "index",
  components: {
    CustomerCase,
    SectionTitle,
    banner,
    Footer,
    FeatureGrid,
    FeatureSection
  },
  data() {
    return {
      bannerList: [],
      featureList: [],
      featureSectionList: [],
      caseList: [],
      featureImage: ''
    }
  },
  watch: {
    // 监听整个路由对象变化
    $route: {
      handler() {
        // 获取到当前解决方案的数据
        this.handleAlgorithmData()
        window.scrollTo(0, 0);
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    // 获取到当前解决方案的数据
    this.handleAlgorithmData()
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    handleAlgorithmData() {
      var data = Algorithm.find(item => item.id == this.$route.query.id);
      if (data) {
        this.bannerList = data.bannerList;
        this.featureList = data.featureList;
        this.featureSectionList = data.featureSectionList;
        this.caseList = data.CustomerCaseList;
        this.featureImage = data.featureImage;
      }

    }
  }
}
</script>

<style scoped>
.fajg-img {
  width: 80%;
  margin: 0 auto;
  display: block;
}

</style>